<div class="">
  <div class="wrap_body mt-2">
    <div class="">
      <div class="m-head">
        <h4 class="d-block d-md-none">Client marketing details</h4>
      </div>

      <div>
        <form [formGroup]="clientFilterForm">
          <div class="filter-section px-3 m-filter">
            <mat-form-field class="mr-5">
              <mat-label> Name/Email </mat-label>
              <input
                matInput
                autocomplete="off"
                formControlName="search"
                type="text"
                placeholder="Search Name or Email"
              />
            </mat-form-field>

            <mat-form-field class="status">
              <mat-label>Leads</mat-label>
              <mat-select formControlName="recommendationType" [(value)]="selectedVerificationStatus">
                <mat-option value="all">Received Email</mat-option>
                <mat-option value="click-through">Click-Through </mat-option>
                <mat-option value="engaged">Engaged </mat-option>
              </mat-select>
            </mat-form-field>
            <button
              color="primary"
              mat-flat-button
              (click)="filterData()"
              [disabled]="isDisableFilterBtn"
              class="ml-auto ml-lg-0"
            >
              Filter
            </button>
            <button
              mat-button
              mat-stroked-button
              color="primary"
              class="ml-2"
              [disabled]="isDisableResetBtn"
              (click)="resetFilter()"
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      <div class="row mb-5">
        <div class="col-lg-12 mt-2">
          <div class="table_base">
            <div class="table-responsive table_wrap" #clientListContainer>
              <table
                mat-table
                [dataSource]="tableDataSource"
                class="mat-elevation-z2 w-100"
                matSort
                matSortActive="lastActivityDate"
                matSortDirection="desc"
                (matSortChange)="sortTable($event)"
              >
                <!-- <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z2 w-100"> -->
                <ng-container matColumnDef="clientName">
                  <th mat-header-cell *matHeaderCellDef>Client Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.fullName }}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
                  <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                </ng-container>

                <ng-container matColumnDef="totalActivityScore">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Score</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.totalActivityScore ? (element.totalActivityScore | number: '1.0-0') : 0 }}
                    <span *ngIf="element.tag && element.tag.length">
                      {{ element.tag[2] || element.tag[1] || element.tag[0] | number: '1.0-0' }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="leadType">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Type</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.leadType | titlecase }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="leadStatus">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      appState?.companyInfoValue &&
                        appState.companyInfoValue[element.leadType + 'LeadCategory'] &&
                        appState.companyInfoValue[element.leadType + 'LeadCategory'][element.leadStatus].displayText
                        | titlecase
                    }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastActivityDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Activity Date</th>

                  <td mat-cell *matCellDef="let element">
                    {{ element.lastActivityDate | date: 'MMM d,  h:mm a' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="activationDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Connected On</th>
                  <td mat-cell *matCellDef="let element">{{ element.activationDate | simpleDate }}</td>
                </ng-container>
                <ng-container matColumnDef="totalCount">
                  <!-- *ngIf="(appState.companyInfo$ | async)?.type == 'default'"> -->
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    {{ selectedLeadStatus == 'click-through' ? 'Listings clicked through' : 'Email Count' }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.totalCount }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="emailVerificationDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Account Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.emailVerificationDate != null ? 'Verified' : 'Unverified' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Lead Capture Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdDate | simpleDate }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: tableColumnList"
                  (click)="fetchClientMarketingDetails(row); $event.stopPropagation()"
                ></tr>
              </table>
            </div>

            <div class="flex_center w-100" *ngIf="!isDataLoading && !investorUsersCount">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No users data found</h4>
                </div>
              </div>
            </div>

            <div class="row ml-0 mr-0">
              <div class="col-lg-12 paginationWrap mt-2">
                <mat-paginator
                  [length]="investorUsersCount"
                  [pageSize]="pageSize"
                  [pageIndex]="pageIndex"
                  [pageSizeOptions]="[10, 20]"
                  (page)="pageChange($event)"
                  showFirstLastButtons
                  class="d-inline-block m-wdh w-100"
                >
                </mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-in-progress" *ngIf="isDataLoading">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div>
  </div>
</div>
